<template>
<v-row justify="center" class="mt-10 main info--text" :style="$vuetify.breakpoint.smAndDown ? 'display: block;' : ''">
    <v-col md="4">
      <v-row>
        <v-col align="start">
          <h2 class="primary--text" style="font-family: Avenir1;">Have questions?</h2> <br/>
          <p class="headers1"> Frequently Asked Questions </p>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="par">
          <p class="balck--text">
            We pride ourselves on transparency and great customer service, which is why no questions go unanswered.
          </p>
          <br/>
          <p>
            <span style="font-weight: bold; font-size: 17px;"> Have more questions? Call Us </span>
            <a class="primary--text" href="tel:+27722459777" style="text-decoration: none;"> 072 245 9777</a>
          </p>
        </v-col>
      </v-row>
    </v-col>
    <v-col align="right" md="6" class="par">
      <v-row justify="right">
        <v-col>
          <v-expansion-panels dark popout>
          <v-expansion-panel style="border-radius: 20px;">
            <v-expansion-panel-header class="headers2" color="info main--text">
              How to book?
            </v-expansion-panel-header>
            <v-expansion-panel-content color="main info--text">
              <v-row justify="center">
                <v-col align="start">
                  <ul class="info--text mt-5">
                      <li> Sign up in 60 seconds with your card or EFT. </li>
                      <li> Enter your waste location. </li>
                      <li> Book different waste types & various products for multiple locations on your dashboard. </li>
                  </ul>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </v-col>
      </v-row>
      <v-row justify="right">
        <v-col>
          <v-expansion-panels dark popout>
          <v-expansion-panel style="border-radius: 20px;">
            <v-expansion-panel-header class="headers2" color="info main--text">
              How does Waste Dash work?
            </v-expansion-panel-header>
            <v-expansion-panel-content color="main info--text">
              <br/>
              <HowItWorks/>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </v-col>
      </v-row>
      <v-row justify="right">
        <v-col>
          <v-expansion-panels dark popout>
          <v-expansion-panel style="border-radius: 20px;">
            <v-expansion-panel-header class="headers2" color="info main--text">
              How do I pay?
            </v-expansion-panel-header>
            <v-expansion-panel-content color="main info--text">
              <Payment/>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </v-col>
      </v-row>
      <v-row justify="right">
        <v-col>
          <v-expansion-panels dark popout>
          <v-expansion-panel style="border-radius: 20px;">
            <v-expansion-panel-header class="headers2" color="info main--text">
              How to get in contact?
            </v-expansion-panel-header>
            <v-expansion-panel-content color="main white--text">
              <ul class="info--text mt-4 text-start">
                <li> <a href="mailto:info@wastedash.com"> info@dashwaste.co.za </a> </li>
                <li> <a href="tel:+27722459777"> 072 245 9777 </a> </li>
              </ul>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </v-col>
      </v-row>
      <v-row justify="right">
        <v-col>
          <v-expansion-panels dark popout>
          <v-expansion-panel style="border-radius: 20px;">
            <v-expansion-panel-header class="headers2" color="info main--text">
              What areas do you service?
            </v-expansion-panel-header>
            <v-expansion-panel-content color="main info--text">
              <ul class="info--text mt-4 text-start">
                <li> Currently center of Atlanta city. </li>
              </ul>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </v-col>
      </v-row>
      <v-row justify="right">
        <v-col>
          <v-expansion-panels dark popout>
          <v-expansion-panel style="border-radius: 20px;">
            <v-expansion-panel-header class="headers2" color="info main--text">
              What waste type to choose?
            </v-expansion-panel-header>
            <v-expansion-panel-content color="main info--text">
              <wasteType/>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </v-col>
      </v-row>
      <v-row justify="right">
        <v-col>
          <v-expansion-panels dark popout>
          <v-expansion-panel style="border-radius: 20px;">
            <v-expansion-panel-header class="headers2" color="info main--text">
              What product to book?
            </v-expansion-panel-header>
            <v-expansion-panel-content color="main info--text">
              <serviceType/>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </v-col>
      </v-row>
      <v-row justify="right">
        <v-col>
          <v-expansion-panels dark popout>
          <v-expansion-panel style="border-radius: 20px;">
            <v-expansion-panel-header class="headers2" color="info main--text">
              What size to book?
            </v-expansion-panel-header>
            <v-expansion-panel-content color="main white--text">
              <tonnage/>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </v-col>
      </v-row>
      <v-row justify="right">
        <v-col>
          <v-expansion-panels dark popout>
          <v-expansion-panel style="border-radius: 20px;">
            <v-expansion-panel-header class="headers2" color="info main--text">
              How long can I keep the bin?
            </v-expansion-panel-header>
            <v-expansion-panel-content color="main info--text">
              <v-row justify="center">
                <v-col align="start">
                  <ul class="info--text mt-4">
                    <li> Bin rental is for 7 days. </li>
                    <li> Contact us for monthly rentals. </li>
                  </ul>
              </v-col>
            </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </v-col>
      </v-row>
      <!--<v-row justify="right">
        <v-col>
          <v-expansion-panels dark popout>
          <v-expansion-panel style="border-radius: 20px;">
            <v-expansion-panel-header class="headers2" color="info main--text">
              Your accredited partners?
            </v-expansion-panel-header>
            <v-expansion-panel-content color="white white--text">
              <v-row justify="center" id="step" class="pt-6 step">
                <v-col align="center">       
                  <v-img 
                  src="@/assets/IWM.png" 
                  alt="Logo"
                  max-width="90"
                  contain
                  class="mb-1"
                  />
                  <br/>
                  <p class="info--text text-justify-center"> Institute of Waste Management since 2009 </p>
                </v-col>
                <v-col align="center" class="img">       
                  <v-img 
                  src="@/assets/City of Cape Town.png" 
                  alt="Logo"  
                  max-width="150"
                  contain
                  />
                  <br/>
                  <p class="main--text text-justify-center"> Accredited City of Cape Town Provider since 2016 </p>
                </v-col>
                <v-col align="center">       
                  <v-img 
                  src="@/assets/MBA.png" 
                  alt="Logo"  
                  max-width="98"
                  contain
                  class="mt-n2"
                  />
                  <br/>
                  <p class="main--text text-justify-center"> Master Builders and Allied Traders' Association since 2021 </p>
                </v-col>
                <v-col align="center">       
                  <v-img 
                  src="@/assets/Umthi.png" 
                  alt="Logo"  
                  max-width="74"
                  contain
                  class="mt-n2"
                  />
                  <br/>
                  <p class="main--text text-justify-center"> Umthi Initiatives since 2020 </p>
                </v-col>
                <v-col align="center">       
                  <v-img 
                  src="@/assets/PeachLogo.png" 
                  alt="Logo"  
                  max-width="105"
                  contain
                  class="mb-5"
                  />
                  <br/>
                  <p class="main--text text-justify-center"> Peach Payments gateaway since 2007 </p>
                </v-col>
              </v-row> 
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </v-col>
      </v-row>-->
      <v-row justify="right">
        <v-col>
          <v-expansion-panels dark popout>
          <v-expansion-panel style="border-radius: 20px;">
            <v-expansion-panel-header class="headers2" color="info main--text">
              What are the benefits?
            </v-expansion-panel-header>
            <v-expansion-panel-content color="main info--text">
              <benefits/>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </v-col>
      </v-row>
      <v-row justify="right">
        <v-col>
          <v-expansion-panels dark popout>
          <v-expansion-panel style="border-radius: 20px;">
            <v-expansion-panel-header class="headers2" color="info main--text">
              How to become a service provider?
            </v-expansion-panel-header>
            <v-expansion-panel-content color="main info--text">
              <HowToBecomeDriver/>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </v-col>
      </v-row>
    </v-col> 
</v-row>
    
</template>
<script>
import HowItWorks from "@/components/howItWorks";
import Payment from "@/components/payment";
import wasteType from "@/components/wasteType";
import serviceType from "@/components/serviceType";
import benefits from "@/components/benefits";
import tonnage from "@/components/tonnage";
import HowToBecomeDriver from "@/components/driver";

export default {
    name: 'faqs',
    components: {
        wasteType,
        serviceType,
        tonnage,
        benefits,
        HowToBecomeDriver,
        HowItWorks,
        Payment,
    },
    data() {
        return {
        }
        
    },
    mounted(){
  }
}
</script>
<style scoped>
.headers1{
  font-family: Avenir1;
  font-style: normal;
  font-weight: 750;
  font-size: 48px;
  line-height: 64px;
}
.headers2{
  font-family: Avenir3; 
  font-style: normal; 
  font-weight: 400; 
  font-size: 20px; 
  line-height: 20px; 
  height: 80px;
}
.par{
  font-family: Avenir3;
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
}
.lastrow{
    margin-bottom: 2cm;
}
.image1{
    margin-top: -0.19cm;
}
.image2{
    margin-top: -0.19cm;
}
#how-it-works{
  border-radius: 26px;
}
@media only screen and (max-width: 580px){
    #main{
      padding-top: 1cm;
    }
    .lastrow{
        margin-bottom: 13cm;
    }
    #step{
    display: block;
  }
  .line-divider{
    display: none;
  }
  .br{
    display: none;
  }
  p, ul{
    text-align: left;
    margin-left: 0.5cm;
    margin-right: 0.5cm;
  }
  .par{
    text-align: center;
  }
  .android{
    display: block;
  }
  .apple{
    display: block;
  }
  .image1{
    margin-top: 0cm;
  }
  .image2{
    margin-top: 0cm;
    margin-left: 0cm;
  }
}

</style>